const source = window.location.host;
const fr = document.querySelector('meta[name="cv-minor-version"]')
const version = document.querySelector('meta[name="cv-major-version"]')
const crossBtns = document.querySelectorAll(".cross-btn")
const qbLoader = document.querySelector(".qb-loader")
const errorMsg = document.querySelector(".error-msg")
const quickFeedbackForm = document.querySelector(".quick-feedback-form")
const voteMsgs = document.querySelectorAll(".vote-msg")
const voteBts = document.querySelectorAll(".vote-btn")
const voteIcons = document.querySelectorAll(".vote-icon")
const navSlug = document.querySelector('meta[name="cv-nav-slug"]')
const inPageToc = document.querySelector(".in-page-toc-tile");

var url, page, existingVote, pressedBtn, elements;

function initQuickFB(){
    
    if(!quickFeedbackForm)
        return;

    // 0th element refers to DOM related to "NO" option
    // 1th element refers to DOM related to "YES" option
    elements = [
        {
            "msg" : voteMsgs[1],
            "icon" : voteIcons[1],
            "btn" : voteBts[1]
        }, 
        {
            "msg" :  voteMsgs[0],
            "icon" : voteIcons[0],
            "btn" : voteBts[0]
        }
    ];

    cleanLocalStorage(); // limit the no. of stored pages to 100
    reset();
    addListeners(elements);     
    crossBtns.forEach(function(crossBtn){
        crossBtn.addEventListener("click",reset)
    });
}

function addListeners(elements){
    //add event listeners on vote components(button,msg,icon)
    elements.forEach((element, index)=>{
        element['btn'].addEventListener("mouseover", ()=>{
            element['icon'].classList.add("fas")
        });
        element['btn'].addEventListener("mouseout", ()=>{
            if(pressedBtn && pressedBtn===index.toString())return;
            element['icon'].classList.remove("fas")
        });
        element['btn'].addEventListener("click",function(){
            voteHandler(existingVote, url, index.toString())
        })
    });
}
function voteHandler(existingVote,url,vote){
    if(existingVote && existingVote===vote)
        return; //if user is voting for the same option again, do nothing
    submitVote(url,vote,existingVote)
}

function reset(){
    //reset all the designs
    url = window.location.href;
    page = normalizeURL(url)
    pressedBtn = null;
    existingVote = null;
    try{
        var pages = localStorage.getItem("cv-quickfeedback")

        if(!pages){
            pages = [];
            localStorage.setItem("cv-quickfeedback",JSON.stringify(pages))
        }else
            pages = JSON.parse(pages)

        for(var i=0;i<pages.length;i++){
            if(pages[i][0]===page){ //checking if the page is already voted
                existingVote = pages[i][1];
                break;
            }
        }
    }
    catch(err){
        //client has disabled local storage
    }

    qbLoader.style.display = "none"
    quickFeedbackForm.style.display = "block"
    inPageToc.style.top = "6rem";

    resetDesignButtons(elements)
    
    errorMsg.style.display = "none"

    if(existingVote){
        designButtons(existingVote)
    }
}


function normalizeURL(s){
    // extract only the unique & constant part from the url
    s = s.substring(s.indexOf(source)+source.length)
    const underscore_pos = s.indexOf("_",s.lastIndexOf("/"))
    s = s.slice(0,underscore_pos===-1?s.length:underscore_pos);
    return s;
}

function submitVote(url,vote,existingVote){
    var previousPage = page
    var previousVote = vote
    const quickfeedback_data = {
        'url' : url,
        'fr' : fr?fr.getAttribute("content"):"",
        'vote' : vote,
        'voteChanged': !existingVote?false:true,
        'site' : navSlug?navSlug.getAttribute("content"):""
        // 'source' : source,
        // 'version' : version.getAttribute("content"),
        // 'page' : normalizeURL(url)
    };
    qbLoader.style.display = "block"
    quickFeedbackForm.style.display = "none"
    fetch("/quickfeedback",{
        'method': 'POST',
        'headers': {
            'content-type': 'application/json',
            'accept': 'text/html',
        },
        'cache': 'no-cache',
        'body': JSON.stringify(quickfeedback_data)
    }).then(function(response){
        qbLoader.style.display = "none"
        if(response.status===200){
            try{
                var pages = JSON.parse(localStorage.getItem("cv-quickfeedback"));
                
                //if page was already voted, update vote
                var i;
                for(i=0;i<pages.length;i++){
                    if(pages[i][0]===previousPage){
                        pages[i][1] = pages[i][1]==="0"?"1":"0";
                        break;
                    }
                }
                //add page and corresponding vote to local storage
                if(i===pages.length)
                    pages.push([previousPage, previousVote])
                localStorage.setItem("cv-quickfeedback",JSON.stringify(pages))
            }catch(ee){
                //client has disabled local storage
            }
            if(previousPage===page) //incase, if user has switched to some other page before arrival of response
                displayMessage(vote)
        }
        else
            throw Exception(response.text())
    }).catch(function(err){
        if(previousPage===page){
            inPageToc.style.top = "9rem";
            errorMsg.style.display = "block";
            qbLoader.style.display = "none"
            console.log(err)
        }
    });
}
function displayMessage(vote){
    if(vote==="0")
        inPageToc.style.top = "13rem";
    quickFeedbackForm.style.display = "none"
    elements[Number(vote)]['msg'].style.display = "block";
    designButtons(vote)
}
function designButtons(vote){
    vote = Number(vote)
    elements[vote]['icon'].classList.add("fas")
    elements[vote^1]['icon'].classList.remove("fas")
    pressedBtn = vote.toString();
}
function resetDesignButtons(elements){
    elements.forEach((element)=>{
        element['msg'].style.display = "none"
        element['icon'].classList.remove("fas")
    })
}
function cleanLocalStorage(){

    var pages = localStorage.getItem("cv-quickfeedback") 
    
    if(!pages) return;

    pages = JSON.parse(pages)

    //remove some old pages from storage
    if(pages.length>100){
        //remove first 10 pages
        pages.splice(0,10);
    }
    localStorage.setItem("cv-quickfeedback",JSON.stringify(pages))
}
export default {initQuickFB,reset}